import { OverlayTrigger, Popover, Tab, Tabs } from "react-bootstrap";
import importAll from "./images";
import Button from "../form-components/Button";
import { forwardRef, useEffect, useLayoutEffect, useRef, useState } from "react";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import { useDispatch, useSelector } from "react-redux";
import { labelListing } from "../../features/user-document/label-listing";
import { debounce, extractAllLabels } from "../../utils/utils";
import { getDocuments } from "../../features/user-document/documentListingSlice";

const images = importAll(
  require.context(
    "../../assets/images/",
    false,
    /\.(png|jpe?g|svg|GIF|webp|json)$/
  )
);

const FilterFooter = ({ onChangeFilter }) => {
	const dispatch = useDispatch();
  const perPage = 10;
	const [searchTags, setSearchTags] = useState("");
	const [currentPageDocs, setCurrentPageDocs] = useState(1);
	const [searchDocs, setSearchDocs] = useState("");
	const { listingData = null, documentListData = null, documentListLoading } = useSelector((state) => ({
    listingData: state?.labelListingSlice?.responseData?.label,
		documentListData: state?.documentListing?.documentListing,
		documentListLoading: state?.documentListing?.isLoading,
  }));
	const projectData = JSON.parse(localStorage.getItem("_user"));

	const [tags, setTags] = useState([]);
	const [filteredTags, setFilteredTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [selectedDocs, setSelectedDocs] = useState([]);
	const [isDocsListEmpty, setIsDocListEmpty] = useState(false);
	const filterRef = useRef(null);
	const [selectedFilterType, setSelectedFilterType] = useState("labels");

	const getDocumentsFunction = () => {
		dispatch(
			getDocuments({
				perPage: perPage,
				page: currentPageDocs,
				project_uuid: projectData?.projects[0]?.uuid,
				search: searchDocs,
			})
		);
	}

	const debounceSearch = debounce((e, setFn, setFnPage) => {
		setFn(e.target.value);
		setFnPage(1);
	}, 600);

	const scrollToBottom = refEl => {
		if (refEl.current) {
			setTimeout(() => {
				const { scrollHeight } = refEl.current;
				refEl.current.scrollTop = scrollHeight;
			}, 200);
		}
	}

	useEffect(() => {
		setTags([]);
		setFilteredTags([]);
		setSelectedTags([]);
		setDocuments([]);
		setSelectedDocs([]);

		dispatch(labelListing(projectData?.projects[0]?.uuid));
		if (!documentListData || documentListData.length === 0) {
			getDocumentsFunction();
		}
	}, []);

	useEffect(() => {
		if (listingData?.length > 0) {
			const allTags = extractAllLabels(listingData);
			setTags([ ...allTags ]);
			setFilteredTags([ ...allTags ]);
		}
	}, [listingData]);

	useEffect(() => {
		if (searchTags) {
			setFilteredTags([ ...tags.filter(tag => tag.name.toLowerCase().includes(searchTags.toLowerCase())) ]);
		}
		else {
			setFilteredTags([ ...tags ]);
		}
	}, [searchTags]);

	useEffect(() => {
		if (currentPageDocs === 1) {
			setDocuments([ ...documentListData ]);
		}
		else {
			setDocuments([ ...documents, ...documentListData ]);
		}
		setIsDocListEmpty(!Boolean(documentListData.length) || documentListData.length < perPage);
	}, [documentListData]);

	useEffect(() => {
		getDocumentsFunction();
	}, [searchDocs, currentPageDocs]);

	useLayoutEffect(() => {
		if (filterRef?.current && currentPageDocs !== 1) {
			scrollToBottom(filterRef);
		}
	}, [documents]);

	useEffect(() => {
		const filterPayload = {
			field_name: selectedFilterType,
			field_type: "string",
			operation: "is",
			field_values: selectedTags.map(value => value.uuid),
		};
		if (selectedFilterType === "documents") {
			filterPayload.field_values = selectedDocs.map(value => value.uuid);
		}
		onChangeFilter(filterPayload.field_values.length > 0 ? filterPayload : null);
	}, [selectedTags,  selectedDocs]);

	const onChangeTags = (tag) => {
		const index = selectedTags.findIndex(t => t.uuid === tag.uuid);
		if (index > -1) {
			selectedTags.splice(index, 1);
		}
		else {
			selectedTags.push(tag);
		}
		setSelectedTags([ ...selectedTags ]);
	}

	const onChangeDocs = (document) => {
		const index = selectedDocs.findIndex(d => d.uuid === document.uuid);
		if (index > -1) {
			selectedDocs.splice(index, 1);
		}
		else {
			selectedDocs.push(document);
		}
		setSelectedDocs([ ...selectedDocs ]);
	}

	const FilterTagstabsPopover = forwardRef((props, ref) => {
		useInfiniteScroll(() => {
			if (!isDocsListEmpty) {
				setCurrentPageDocs(page => page + 1);
			}
		}, ref);

		return (
			<div>
				<div className="filtertags-dropdown">
					<Tabs activeKey={selectedFilterType} id="uncontrolled-tab-example" onSelect={e => setSelectedFilterType(e)}>
						<Tab eventKey="labels" title="Tags">
							<div className="intro-searchbar-main">
								<div className="intro-searchbar">
									<button
										disabled=""
										type="submit"
										className="filter-search-btn"
									></button>
									<span className="selected-number">{selectedTags.length} selected</span>
									<input
										type="text"
										className="form-control"
										name="search"
										placeholder="Search"
										value={searchTags}
										onChange={e => setSearchTags(e.target.value)}
										autoFocus={Boolean(searchTags)}
									/>
								</div>
							</div>
							<div className="px-1 pb-2">
								<div className="cmn-list-prsona">
									<ul>
										{filteredTags.length === 0
											? <li>
												<label className="cmn-fl-label">
													No tags found.
												</label>
											</li>
											: filteredTags.map(tag => (
												<li key={tag.uuid}>
													<input
														className="form-check-input"
														type="checkbox"
														id={"flexCheckDefault_" + tag.uuid}
														checked={selectedTags.map(t => t.uuid).includes(tag.uuid)}
														onChange={() => onChangeTags(tag)}
													/>
													<label htmlFor={"flexCheckDefault_" + tag.uuid} className="cmn-fl-label">
														<p className="mb-0">{tag.name}</p>
														<img src={images["checkfl.svg"]} alt="checkfl" />
													</label>
												</li>
											)) 
										}
									</ul>
								</div>
							</div>
						</Tab>
						<Tab eventKey="documents" title="Documents">
							<div className="intro-searchbar-main">
								<div className="intro-searchbar">
									<button
										disabled=""
										type="submit"
										className="filter-search-btn"
									></button>
									<span className="selected-number">{selectedDocs.length} selected</span>
									<input
										type="text"
										className="form-control"
										name="search"
										placeholder="Search"
										defaultValue={searchDocs}
										onChange={e => { e.persist(); debounceSearch(e, setSearchDocs, setCurrentPageDocs); }}
										autoFocus={Boolean(searchDocs)}
									/>
								</div>
							</div>
							<div className="px-1 pb-2">
								<div className="cmn-list-prsona" ref={r => ref.current = r}>
									<ul>
										{documents.length === 0
												? <li>
													<label className="cmn-fl-label">
														No documents found.
													</label>
												</li>
												: documents.map(document => (
													<li key={document.uuid}>
														<input
															className="form-check-input"
															type="checkbox"
															id={"flexCheckDefault_" + document.uuid}
															checked={selectedDocs.map(d => d.uuid).includes(document.uuid)}
															onChange={() => onChangeDocs(document)}
														/>
														<label htmlFor={"flexCheckDefault_" + document.uuid} className="cmn-fl-label">
															<p className="mb-0">{document.title}</p>
															<img src={images["checkfl.svg"]} alt="checkfl" />
														</label>
													</li>
												)) 
											}
									</ul>
								</div>
							</div>
						</Tab>
					</Tabs>
				</div>
				{documentListLoading &&
					<div className="text-center p-1 pb-2 custom-loader-riv">
						<div className="custom-loader"></div>
					</div>
				}
			</div>
		)
	});

	const clearValue = () => {
		if (selectedFilterType === "labels") {
			setSelectedTags([]);
		}
		else {
			setSelectedDocs([]);
		}
	}

	const getSelectedValues = (list, textKey = "name") => {
		list = [ ...list ];
		const selectedValueText = list.slice(0, 2).map(value => value[textKey]).join(", ");
		let tooltipLabel = "", tooltipText = "";
		if (list.length > 2) {
			tooltipLabel = "+" + (list.length - 2);
			tooltipText = list.slice(2).map(value => value[textKey]).join(", ");
		}
		return { selectedValueText, tooltipLabel, tooltipText };
	}

	const { selectedValueText, tooltipLabel, tooltipText} = getSelectedValues(
		selectedFilterType === "labels" ? selectedTags : selectedDocs,
		selectedFilterType === "labels" ? "name" : "title"
	);
	
	return (
		<div className="d-flex align-items-center flex-nowrap sm:flex-wrap">
			<OverlayTrigger
				trigger="click"
				placement="top"
				overlay={props => (
					<Popover className="filter-chat-popover filter-tag-move-tip" id="popover-filter-tabs" {...props}>
						<Popover.Body>
							<FilterTagstabsPopover ref={filterRef} />
						</Popover.Body>
					</Popover>
				)}
				rootClose
			>
				<span>
					<Button className="btn p-0 bg-transparent border-0 tags-fl-btn">
						<img
							className="w-100"
							src={images["icn_filter.svg"]}
							alt="icn_filter"
						/>
					</Button>
				</span>
			</OverlayTrigger>
			{selectedValueText
				? <div className="d-flex align-items-center flex-nowrap sm:flex-wrap">
					<span className="selected-tag-resulttxt">
						{selectedValueText}
						<button type="button" className="btn" onClick={clearValue}>
							<svg
								className="close-icon"
								xmlns="http://www.w3.org/2000/svg"
								width="13.414"
								height="13.414"
								viewBox="0 0 13.414 13.414"
							>
								<g
									id="Group_31758"
									data-name="Group 31758"
									transform="translate(0.707 0.707)"
								>
									<path
										id="Path_48155"
										data-name="Path 48155"
										d="M0,0,12,12"
										fill="none"
										stroke="#313b5c"
										strokeWidth="2"
									></path>
									<path
										id="Path_48154"
										data-name="Path 48154"
										d="M12,0,0,12"
										fill="none"
										stroke="#313b5c"
										strokeWidth="2"
									></path>
								</g>
							</svg>
						</button>
					</span>
					{tooltipLabel
						? <div className="mb-0 slected-more-number">
							{tooltipLabel}
							<div className="slected-more-number-tooltip">{tooltipText}</div>
						</div>
						: null
					}
				</div>
				: null
			}
		</div>
	)
};

export default FilterFooter
